exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.emptyBox[data-v-36e8070c]{\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.emptyImg[data-v-36e8070c]{\n    width: 4.26rem;\n    height: 3.28rem;\n    background: url(" + require("assets/collection.png") + ") no-repeat center/cover;\n    margin-top: 2.28rem;\n    margin-bottom: .7rem;\n    font-size: .3rem;\n    color: #6F6F6F;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-36e8070c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/myCollection.vue
// module id = 10Jp
// module chunks = 1